import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import LineTitle from '../atoms/titles/LineTitle';
import LinkButton from '../atoms/button/LinkButton';
import RoomStateLabel from '../atoms/label/Label';
import Tag from '../atoms/tag/Tag';
import PriceBlock from '../molecules/PriceBlock';
import { makeQueryStringsWithDuplicatedSessionKey, makeAdditionalParamsPlanDetail } from '../../utils/queryParams';
import { BASENAME, PLAN_LIST_HIDE_TAGS } from '../../constants';
import { usePrice } from '../../utils/price';
import ModalPlanOptionSummary from '../modal/ModalPlanOptionSummary';

const FEMALE_TAG_ID = 'female_only';

const selector = (state) => ({
  flight: state.flight,
});

const PlanListView = ({ plans }) => {
  const { flight: flightState } = useSelector(selector);

  const {
    searchedFlightsInput, selectedOutboundFlight, selectedInboundFlight,
    fetchingOutbound, fetchingInbound, selectedOutboundDate
  } = flightState;

  const hidePrice = fetchingOutbound || fetchingInbound;
  const priceClassName = hidePrice ? 'hidden' : '';
  const [showPlanOptionModal, setShowPlanOptionModal] = useState(false);
  const [modalSubtitle, setModalSubtitle] = useState('');
  const [modalExplanation, setModalExplanation] = useState('');

  return (
    <div className="PlanList">
      {plans.map((p, index) => {
        const {
          id,
          name,
          stocks,
          recommendationPoint,
          roomType,
          hotel,
          tags: planTags,
          femaleOnlyPlan,
          mealCondition,
          otherItinerary,
          landingFlag,
        }= p;

        const { id: roomTypeId } = roomType;

        const roomStateLittle = stocks < 7;
        const roomStateLabelColor = roomStateLittle ? 'red' : 'gray';
        const roomStateLabelText = roomStateLittle ? '空室わずか' : '空室あり';

        const { picsURL, tags: hotelTags } = hotel;
        const people= searchedFlightsInput && searchedFlightsInput.people;

        const { subtitle, usage, explanation } = otherItinerary || {};
        const handleClickPlanOption = (_subtitle, _explanation) => {
          setShowPlanOptionModal(true);
          setModalSubtitle(_subtitle);
          setModalExplanation(_explanation);
        };

        const planDetailParams = makeAdditionalParamsPlanDetail(id, roomTypeId);

        const handleClickButton = () => {
          const search = makeQueryStringsWithDuplicatedSessionKey(planDetailParams);
          const planDetailLink = `${BASENAME}/plan_detail?${search}`;
          window.open(planDetailLink, '_blank');
        };

        const { totalPrice, pricePerAdult } = usePrice(people, selectedOutboundFlight, selectedInboundFlight, [p], selectedOutboundDate);

        let tags = [...hotelTags, ...planTags];

        if (femaleOnlyPlan) {
          const femaleTag = {
            id: FEMALE_TAG_ID,
            name: '女性限定',
            tagGroup: {},
          };

          tags.push(femaleTag);
        }

        //施設関連のタグを除外
        tags = tags.filter(tag => tag.tagGroup && !PLAN_LIST_HIDE_TAGS.includes(tag.tagGroup.name));

        return (
          <div key={`${id}-${roomTypeId}-${index}`} className="planListInner">
            <div className="header">
              <div className="headerLeft">
                <LineTitle>
                  <span className="planListLineTitle" onClick={handleClickButton}>{name}</span>
                  {/* https://gitlab.fqsv.net/dp-plus/front/issues/144 */}
                  {/* <span className="courseCode">［コースコード］{id}</span> */}
                </LineTitle>
              </div>
            </div>
            <div className="body">
              <div className="bodyLeft">
                <div className="thumbnailImage">
                  <img src={picsURL} alt="" />
                </div>
              </div>
              <div className="bodyRight">
                <p
                  className="text"
                  dangerouslySetInnerHTML={{ __html: recommendationPoint }}
                />
              </div>
            </div>
            <div className="footer">
              <div className="RecommendPlanLabel">
                <div className="recommendTagItems">
                  {tags && tags.map((t) => {
                    const { id, name, tagGroup } = t;
                    if(tagGroup && 'name' in tagGroup){
                      if (tagGroup.name === '支払方法') {
                        return null;
                      }
                    }

                    return (
                      <div className="tagItem" key={id}>
                        <Tag>{name}</Tag>
                      </div>
                    );
                  })}
                  {mealCondition && (
                    <div className="tagItem">
                      <Tag>{mealCondition}</Tag>
                    </div>
                  )}
                </div>
                <div className="recommendLabel">
                  <RoomStateLabel color={roomStateLabelColor}>{roomStateLabelText}</RoomStateLabel>
                </div>
              </div>
              {landingFlag ? (
                <div className="planOptionLabel" onClick={() => handleClickPlanOption(subtitle, explanation)}>
                  <span>{subtitle}</span>
                </div>
              ) : null}
              <div className="detail">
                <PriceBlock priceTotal={totalPrice} adultPrice={pricePerAdult} className={priceClassName} />
                <div className="action">
                  <LinkButton buttonType="cta" onClick={handleClickButton}>プランの詳細</LinkButton>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      
      <ModalPlanOptionSummary
        open={showPlanOptionModal}
        onClose={() => setShowPlanOptionModal(false)}
        subtitle={modalSubtitle}
        explanation={modalExplanation}
        setShowPlanOptionModal={setShowPlanOptionModal}
      />
    </div>
  );
};

PlanListView.propTypes = {
  plans: PropTypes.array.isRequired,
};

export default PlanListView;
